module.exports = __webpack_public_path__ + "img/green_island.524b0f0c.svg";